import { ThemeProvider } from "styled-components";
import { useState, useEffect } from "react";
import { darkTheme, lightTheme } from "./utils/Themes.js";
import Navbar from "./components/Navbar";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import HeroSection from "./components/HeroSection";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Experience from "./components/Experience";
import Education from "./components/Education";
import Certifications from "./components/Certifications";
import ProjectDetails from "./components/ProjectDetails";
import ThreeBackground from "./components/ThreeBackground";
import styled from "styled-components";
import { Analytics } from "@vercel/analytics/react";

const Body = styled.div`
  background-color: ${({ theme }) => theme.bg};
  width: 100%;
  overflow-x: hidden;
  position: relative;
  z-index: 1;
`;

const ContentLayer = styled.div`
  position: relative;
  z-index: 1;
`;

const SectionWrapper = styled.div`
  background: ${({ theme }) =>
    `linear-gradient(180deg, transparent 0%, ${theme.glow} 50%, transparent 100%)`};
  width: 100%;
`;

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem("darkMode");
    return saved ? JSON.parse(saved) : true;
  });

  useEffect(() => {
    localStorage.setItem("darkMode", JSON.stringify(darkMode));
  }, [darkMode]);

  const [openModal, setOpenModal] = useState({ state: false, project: null });

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Router>
        <ThreeBackground darkMode={darkMode} />
        <ContentLayer>
          <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />
          <Body>
            <HeroSection />
            <SectionWrapper>
              <Skills />
              <Certifications />
            </SectionWrapper>
            <Experience />
            <Projects openModal={openModal} setOpenModal={setOpenModal} />
            <SectionWrapper>
              <Education />
              <Contact />
            </SectionWrapper>
            <Footer />
            {openModal.state && (
              <ProjectDetails
                openModal={openModal}
                setOpenModal={setOpenModal}
              />
            )}
          </Body>
        </ContentLayer>
      </Router>
      <Analytics />
    </ThemeProvider>
  );
}

export default App;
